import { CircularProgress } from "@mui/material";
import React from "react";

export const FetchBoundary = ({ loading, error, children, style, className }) => {
  const defaultDisplay = loading ? <CircularProgress /> : children;
  return (
    <div className={className} style={style}>
      {error ? `Error: ${error.message}` : defaultDisplay}
    </div>
  );
};
